import React from "react";
import { Link } from "react-router-dom";

import Divider from "./divider";

function FundraiseNav() {
  const activeSetting =
    document.location.href.split("/")[
      document.location.href.split("/").length - 1
    ];

  return (
    <>
      <div className="settings_menu">
        <h4 className="my-3">Fundraise</h4>
        <Divider
          style={{
            position: "relative",
            left: 0,
            marginBottom: 16,
            height: 2,
            marginRight: 4,
          }}
        />

        <ul>
          <div className="sidemenu">
            <li className="nav-item">
              <Link
                to={"/org/fundraise/manage"}
                className={
                  "nav-link " + (activeSetting === "manage" ? "active" : "")
                }
              >
                <i className="la la-usd"></i>
                <span>Manage Rounds</span>
              </Link>
            </li>
          </div>
        </ul>
      </div>
    </>
  );
}

export default FundraiseNav;
